var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumHighRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 348.477,
    height: 172.705,
    viewBox: "0 0 348.477 172.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(-59.119 -225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(59.119 225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M0,162.449H67.041A107.139,107.139,0,0,1,115.435,74.34L78.672,18.282A174.1,174.1,0,0,0,0,162.449",
    transform: "translate(0 10.256)",
    fill: "#21b537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M145.964,0A173.408,173.408,0,0,0,50.4,28.536L87.162,84.595a107.218,107.218,0,0,1,118.271.423L242.19,28.969A173.408,173.408,0,0,0,145.964,0",
    transform: "translate(28.273 0)",
    fill: "#ffbc19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M186.475,18.558,149.717,74.607a107.155,107.155,0,0,1,47.729,87.687h67.041A174.1,174.1,0,0,0,186.475,18.558",
    transform: "translate(83.989 10.411)",
    fill: "#ed2926"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M20.837,90.486l1.247-4.238,9.285,2.733,1.672-5.676,3.286.969-2.917,9.912Z",
    transform: "translate(11.689 46.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M28.38,87.294c-3.675-1.5-5.165-5.485-3.551-9.439s5.465-5.758,9.14-4.26,5.167,5.485,3.553,9.438-5.463,5.762-9.141,4.261m3.906-9.572a2.957,2.957,0,1,0-2.221,5.445,2.957,2.957,0,1,0,2.221-5.445",
    transform: "translate(13.566 40.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M38,58.469l9.254,10.2-2.376,4.1L37.754,71.1l4.95,5.44-2.374,4.1L26.873,77.707l2.281-3.94,7.6,1.756-5.245-5.829,2.037-3.518,7.68,1.8L35.9,62.1Z",
    transform: "translate(15.075 32.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M97.713,33.158l-1.559-5.769-1.531,5.364-1.884.5L88.814,29.54l1.474,5.577-3.9,1.03L83.046,23.466l3.512-.929,5.915,5.668,2.237-7.819,3.514-.927,3.386,12.671Z",
    transform: "translate(46.588 10.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M107.079,27.77l.484,3.3L96.778,32.648l-1.9-12.972,10.541-1.542.482,3.3-6.242.913.222,1.52,5.485-.8.459,3.152-5.482.8.25,1.7Z",
    transform: "translate(53.227 10.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M103.519,18.012l6.455-.276c4.38-.187,7.5,2.173,7.674,6.233s-2.732,6.678-7.112,6.865l-6.455.276ZM110.2,27.4a2.886,2.886,0,0,0,2.991-3.241,2.886,2.886,0,0,0-3.258-2.972l-1.851.078.265,6.214Z",
    transform: "translate(58.073 9.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1970",
    "data-name": "Rectangle 1970",
    width: 13.11,
    height: 4.42,
    transform: "matrix(0.038, -0.999, 0.999, 0.038, 177.352, 40.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M118.062,24.962l.832-7.16,4.391.512-.821,7.029c-.231,1.993.445,2.824,1.673,2.966s2.078-.51,2.309-2.5l.82-7.031,4.315.5-.834,7.159c-.454,3.909-3.061,5.885-7.06,5.42s-6.08-2.989-5.624-6.9",
    transform: "translate(66.197 9.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M138.183,34.54l1.356-5.819-3.887,4-1.894-.454-1.7-5.126-1.347,5.61-3.915-.943,3.061-12.747,3.533.848,2.521,7.791,5.674-5.823,3.533.849L142.1,35.48Z",
    transform: "translate(71.133 10.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M197.5,64.524,186.8,72.1,184.244,68.5l3.943-2.793-2.363-3.333-3.941,2.794-2.555-3.606,10.7-7.583,2.555,3.607-3.79,2.686,2.36,3.331,3.79-2.686Z",
    transform: "translate(100.6 30.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1971",
    "data-name": "Rectangle 1971",
    width: 13.11,
    height: 4.421,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, 288.293, 104.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M196.158,76.313l1.7,3.439-4.972,2.459a10.575,10.575,0,0,1-4.024-4.38c-1.876-3.795-.713-7.817,2.9-9.6s7.512-.27,9.432,3.609a7.449,7.449,0,0,1,.39,6.492L198.1,76.9a3.741,3.741,0,0,0-.011-3.275,3.28,3.28,0,0,0-5.9,2.853,4.063,4.063,0,0,0,1,1.3Z",
    transform: "translate(105.455 37.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M207.5,87.509l-12.318,4.5-1.516-4.152,4.539-1.659-1.4-3.837-4.541,1.661-1.517-4.154,12.316-4.5,1.519,4.154-4.363,1.594,1.4,3.835,4.366-1.594Z",
    transform: "translate(107.008 42.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MEDIUM_HIGH_Risk",
    "data-name": "MEDIUM  HIGH Risk",
    transform: "translate(230.201 365.05)",
    fill: "#171b21",
    fontSize: 21,
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50,
    y: 0
  }, "MEDIUM "), /*#__PURE__*/React.createElement("tspan", {
    x: -57,
    y: 23
  }, "HIGH RISK")), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_12",
    "data-name": "Polygon 12",
    d: "M11.2.922a1,1,0,0,1,1.536,0l9.832,11.8a1,1,0,0,1-.768,1.64H2.135a1,1,0,0,1-.768-1.64Z",
    transform: "translate(276.128 311.352) rotate(30)",
    fill: "#20242c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumHighRisk);
export default __webpack_public_path__ + "static/media/mediumHighRisk.522490e70169b94ebf062939ca1d78f0.svg";
export { ForwardRef as ReactComponent };